import { format, parse } from 'date-fns';

export const formatIST = (dateStr?: string | null): string => {
  if (!dateStr) return 'never';
  const formatted = new Date(dateStr).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  return `${formatted} IST`;
};

// Backend chart data always comes back as plain "YYYY-MM-DD" date-only strings (the calendar day
// the user selected, no time component). `new Date("YYYY-MM-DD")` parses that as UTC midnight,
// and formatting it with toLocaleDateString() then converts to the browser's LOCAL timezone —
// in any timezone behind UTC that silently shifts the displayed label back a day (e.g. selecting
// 30 Jul renders as "29 Jul" on the chart). Parsing with date-fns `parse` instead treats the
// string as a local calendar date, so the label always matches exactly what was selected/returned.
export const formatChartDate = (dateStr: string, fmt: string = 'dd MMM'): string => {
  if (!dateStr) return '';
  return format(parse(dateStr, 'yyyy-MM-dd', new Date()), fmt);
};
